import type { FC } from 'react';

import type { Account, AdditionalData } from '@shared/products-types';
import { t } from '@luna/i18n';
import { useNotifications } from '@shared/snackbar';
import { logger } from '@luna/logger';
import type { ProductWithHelpers } from '@shared/products-core';
import { ProductColorChangeDropdown } from '@retail/products-customisation';

import { updateGAPIAccountById } from '../../gAPIAccountEntitySlice';
import { CardMenuDropdownToggle } from '../../overview-actions-dropdown/CardMenuDropdownToggle';

interface Props {
    account: ProductWithHelpers<Account>;
}

export const ColorChangeDropdown: FC<Props> = ({ account }) => {
    const { displayError } = useNotifications('overview-dropdown-actions');

    const handleSave = async (selectedColor: string) => {
        const { id } = account;
        try {
            await updateGAPIAccountById({
                id,
                changes: {
                    id,
                    additionalData: {
                        color: selectedColor.toUpperCase(),
                    } as unknown as AdditionalData,
                },
            });
        } catch (error) {
            logger.error(error);
            displayError(t('mainOverview.action.changeColor.error'));
        }
    };

    return (
        <ProductColorChangeDropdown
            data-cy="dashboard-color-change-dropdown"
            actionButtonDataCy="color-change-save-button"
            toggle={<CardMenuDropdownToggle data-cy="color-change-toggle-dropdown" />}
            onColorSave={handleSave}
            colorChangeContext="overview"
            accountType={account.type}
            trigger="overview"
        />
    );
};
